window.Messages = {
  send_message: function (options) {
    var data;
    data = options.data;
    return $.ajax({
      type: "POST",
      dataType: "json",
      url: $r.api_v0_messages_path({
        subdomain_param: "api"
      }),
      data: data
    });
  }
};